<demo-guide-menu></demo-guide-menu>

<demo-welcome></demo-welcome>

<demo-colors></demo-colors>

<demo-typography></demo-typography>

<demo-grid></demo-grid>

<demo-spacing></demo-spacing>

<demo-global-message></demo-global-message>

<demo-alerts></demo-alerts>

<demo-toasters></demo-toasters>

<demo-buttons></demo-buttons>

<demo-form></demo-form>

<demo-collapse-list></demo-collapse-list>

<demo-toggle-text></demo-toggle-text>

<demo-modal></demo-modal>

<demo-loader></demo-loader>

<demo-table></demo-table>

<demo-table-pro></demo-table-pro>

<demo-screen-view></demo-screen-view>
